import React, { useState, useEffect } from 'react';
import MessageBus from './../../Messagebus'; // Import the message bus
import { sleep } from '../../../../utils/utility';

const FieldWrapper = (globalProps) => {
    const { component: Component, value, onChange, ...initialProps } = globalProps;
    const [props, setProps] = useState({ ...initialProps });
    const { index, id = '', sectionId = '', rules = [], size = 6, hidden = false } = props;
    /* Rules:
         {
                                "valuesIn": [],
                                "targetField": "resultKey",
                                "targetSection": "compantFilter",
                                "sameIndex": true,
                                "changes": {
                                    "hidden": true
                                }
                            }
    
    */

    const handleFieldChange = (payload) => {


        const { updatedValue = {} } = payload;
        const { sectionId: sourceSectionId = '', fieldId: sourceFieldId = '', value: sourceValue, rule = {}, index: sourceIndex } = updatedValue;
        const { valuesIn = [], targetFields = [] = '', changes = {}, targetSection = '', sameIndex = false, enabled = true } = rule;
        if (!enabled)
            return;
        let conditionStringDebug = "";

        let condition = targetSection ? sectionId === targetSection : true;
        conditionStringDebug += condition ? "Section Matched\n" : 'Section Not Matched\n';
        condition = targetFields.length > 0 ? condition && targetFields.includes(id) : condition;
        conditionStringDebug += condition ? "Field Matched\n" : 'Field Not Matched\n';
        condition = valuesIn.length > 0 ? condition && valuesIn.includes(sourceValue) : condition;
        conditionStringDebug += condition ? "Values Matched\n" : 'Values Not Matched\n';
        condition = sameIndex ? condition && index === sourceIndex : condition;
        conditionStringDebug += condition ? "Index Matched\n" : 'Index Not Matched\n';

        let logCondition = false;

        // if (logCondition) {
        //     console.log("handleFieldChange", payload, globalProps);
        //     console.log("Condition = ", condition, conditionStringDebug);
        // }


        if (condition) {
            const { value: newValue, ...restChanges } = changes;
            setProps((prevProps) => {
                return { ...prevProps, ...restChanges };
            });
            if (newValue !== undefined) {
                onChange(id, newValue);
            }
        }
    };

    // Subscribe to field value changes
    useEffect(() => {
        MessageBus.subscribe('fieldValueChanged', handleFieldChange);
        return () => {
            MessageBus.unsubscribe('fieldValueChanged', handleFieldChange);
        };
    }, []);

    // Subscribe to trigger rules
    useEffect(() => {
        MessageBus.subscribe('executeRules', executeRules);
        return () => {
            MessageBus.unsubscribe('executeRules', executeRules);
        };
    }, []);

    // useEffect(() => {
    //     const applyRules = async () => {
    //         await sleep(200);
    //         // console.log("FieldWrapper-useEffect[]", id, value);
    //         for (const rule of rules) {
    //             MessageBus.publish('fieldValueChanged', {
    //                 updatedValue: { sectionId, fieldId: id, value, rule, index },
    //             });
    //         }
    //     }
    //     applyRules();
    // }, []);

    const handleChange = (fieldId, value) => {
        onChange(fieldId, value);
        for (const rule of rules) {
            MessageBus.publish('fieldValueChanged', {
                updatedValue: { sectionId, fieldId, value, rule, index },
            });
        }
    };

    const executeRules = () => {
        // if (id == 'type') {
        //     console.log("executeRules", id, value);
        // }
        for (const rule of rules) {
            MessageBus.publish('fieldValueChanged', {
                updatedValue: { sectionId, fieldId: id, value, rule, index },
            });
        }
    }

    if (hidden)
        return null;

    const desktopSize = Math.max(1, Math.min(12, Number(size) || 6));
    const mobileSize = desktopSize >= 6 ? 12 : 6;
    const fieldWidthClass = `col-md-${desktopSize} col-sm-${mobileSize} col-${mobileSize}`; // Desktop follows config, mobile/tablet shows 2 per row where possible

    // if (id == 'type') {
    //     console.log("FieldWrapper", id, value);
    // }

    return (<div className={`${fieldWidthClass} mb-3`} key={`${sectionId}-${id}-${index}`}>
        <Component {...props} value={value} onChange={handleChange} />
    </div>);
};

export default FieldWrapper;
